import moment from 'moment';
import { RouteComponentProps } from 'react-router-dom';

export type Dictionary<T=any> = { [key: string]: T };

export interface RouteProps extends RouteComponentProps {
	location: {
		hash: string;
		key: string;
		pathname: string;
		search: string;
		state: string | undefined;
	};
	match: {
		isExact: boolean;
		params: Dictionary;
		path: string;
		url: string;
	};
}

export function parseDate(value: string) {
  let format: string | undefined;
  if (!value) return undefined;
  if (/^\d+$/.test(value)) return moment().startOf('day').add(parseInt(value, 10), 'day').toDate();
  if (/^\d{4}-\d{1,2}-\d{1,2}T\d{1,2}:\d{1,2}:\d{1,2}/.test(value)) format = undefined;
  else if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(value)) format = 'M-D-Y';
  else if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) format = 'M/D/Y';
  else if (/^\d{1,2}-\d{1,2}-\d{4}\s+\d{1,2}:\d{1,2}:\d{1,2}$/.test(value)) format = 'M-D-Y H:M:S';
  else if (/^\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{1,2}:\d{1,2}$/.test(value)) format = 'M/D/Y H:M:S';
  else if (/^\d{1,2}-\d{1,2}-\d{4}\s+\d{1,2}:\d{1,2}:\d{1,2}\s+[ap]m$/i.test(value)) format = 'M-D-Y h:M:S a';
  else if (/^\d{1,2}\/\d{1,2}\/\d{4}\s+\d{1,2}:\d{1,2}:\d{1,2}\s+[ap]m$/i.test(value)) format = 'M/D/Y h:M:S a';
  else return undefined;
  return moment(value, format).toDate();
}

export function parseDateRange(value: string) {
  if (!value) value = '1';

  value = value.replace(/\s+/g, '');

  if (/^\d+$/.test(value)) {
    return {
      value,
      n: parseInt(value, 10),
      from: moment().startOf('day').subtract(parseInt(value, 10) - 1, 'day').format('MM/DD/YYYY'),
      to: moment().startOf('day').add(1, 'day').format('MM/DD/YYYY'),
    };
  }

  let from: moment.Moment;
  let to: moment.Moment;
  if (value.endsWith('-')) {
    from = moment(parseDate(value.substr(0, value.length - 1).trim())).startOf('day');
    to = moment().startOf('day').add(1, 'day');
  } else if ((value.match(/-/g) || []).length === 1) {
    const i = value.indexOf('-');
    from = moment(parseDate(value.substr(0, i).trim())).startOf('day');
    to = moment(parseDate(value.substr(i + 1).trim())).startOf('day').add(1, 'day');
  } else if (value.indexOf(' ') > 0) {
    const i = value.indexOf(' ');
    from = moment(parseDate(value.substr(0, i).trim())).startOf('day');
    to = moment(parseDate(value.substr(i + 1).trim())).startOf('day').add(1, 'day');
  } else if (parseDate(value)) {
    from = moment(parseDate(value)).startOf('day');
    to = moment(parseDate(value)).startOf('day').add(1, 'day');
  } else {
    from = moment().startOf('day');
    to = moment().startOf('day').add(1, 'day');
  }

  return {
    value,
    n: to.diff(from, 'days'),
    from: from.format('MM/DD/YYYY'),
    to: to.format('MM/DD/YYYY'),
  };
}

export function parseUrlParams(query = window.location.search): Dictionary<string> {
  return query ? query.substr(1).split('&').reduce((result, value) => Object.assign(result, { [value.substr(0, value.indexOf('='))]: decodeURIComponent(value.substr(value.indexOf('=') + 1)) }), {}) : {};
}

export function formatUrlParams(params: Dictionary) {
  const keys = Object.keys(params).filter((key) => !!params[key]);
  if (keys.length > 0) return `?${keys.map((key) => (params[key] ? `${key}=${params[key]}` : key)).join('&')}`;
  return '';
}
